import React, { useState } from 'react';
import {
  Box,
  Typography,
  Stack,
  Tabs,
  Tab,
  Accordion,
  AccordionSummary,
  AccordionDetails,
} from '@mui/material';
import {
  DescriptionOutlined,
  RemoveCircle,
  AddCircle,
} from '@mui/icons-material';

// Data for the FAQ items
const faqData = [
  {
    id: 'panel1',
    question: 'What are Expert mock interviews? Why should I take expert mock interviews?',
    answer: 'At Scaler every learner has Mandatory Interviews one for each module. You can schedule a expert mock interview with an expert for the required module and seek personalized advice for an interview as a practice, or simulation of an actual job interview. expert mock interviews are mandatory as any specific module is marked as cleared only after you pass a expert mock interview for the corresponding module. Clearing a expert mock interview for a module can increase the possibility of your job opportunities.',
  },
  {
    id: 'panel2',
    question: 'What impact do expert mock interviews have on my career?',
    answer: 'This is the answer for the career impact question.', // Placeholder answer
  },
  {
    id: 'panel3',
    question: 'How many expert mock interviews can I take?',
    answer: 'This is the answer for how many interviews you can take.', // Placeholder answer
  },
  {
    id: 'panel4',
    question: 'What is the difference between Mandatory and Additional Interviews?',
    answer: 'This is the answer for the difference between interview types.', // Placeholder answer
  },
  {
    id: 'panel5',
    question: 'What happens if I skip Mandatory Interviews?',
    answer: 'This is the answer for what happens if you skip interviews.', // Placeholder answer
  },
  {
    id: 'panel6',
    question: 'What happens if I am not ready to take expert mock interviews and my interviews expire?',
    answer: 'This is the answer for what happens if your interviews expire.', // Placeholder answer
  },
];

const FaqPage = () => {
  // Set the default active tab to FAQ's
  const [tabIndex, setTabIndex] = useState(1); 
  
  // State to manage which accordion is expanded. panel1 is expanded by default as in the image.
  const [expanded, setExpanded] = useState('panel1');

  const handleTabChange = (event, newValue) => {
    setTabIndex(newValue);
  };

  const handleAccordionChange = (panel) => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false);
  };

  return (
    <Box sx={{ p: { xs: 2, md: 4 }, bgcolor: 'background.paper' }}>
      <Stack spacing={3}>
        {/* Header */}
        <Box>
          <Typography variant="body2" color="text.secondary">
            EXPERT MOCK INTERVIEW
          </Typography>
          <Typography variant="h4" fontWeight="bold">
            Session Guidelines and FAQ's
          </Typography>
        </Box>

        {/* Tabs */}
        <Box>
          <Tabs value={tabIndex} onChange={handleTabChange} type="button">
            <Tab label="General Guidelines" />
            <Tab label="FAQ's" />
          </Tabs>
        </Box>

        {/* Conditional rendering for the FAQ tab content */}
        {tabIndex === 1 && (
          <Stack spacing={3}>
            <Typography variant="h6" fontWeight="bold">
              Frequently Asked Questions
            </Typography>

            {/* <Stack spacing={2}> */}
            <Box display="flex" flexDirection="column" gap={2}>
              {faqData.map((faqItem) => (
                <Accordion
                  key={faqItem.id}
                  expanded={expanded === faqItem.id}
                  onChange={handleAccordionChange(faqItem.id)}
                  bordered // This custom prop is from your theme.js!
                >
                  <AccordionSummary
                    expandIcon={
                      expanded === faqItem.id ? (
                        <RemoveCircle color="primary" />
                      ) : (
                        <AddCircle color="primary" />
                      )
                    }
                    aria-controls={`${faqItem.id}-content`}
                    id={`${faqItem.id}-header`}
                  >
                    <Stack direction="row" alignItems="center" spacing={1.5}>
                      <DescriptionOutlined color="action" />
                      <Typography fontWeight="500" color="secondary.main">
                        {faqItem.question}
                      </Typography>
                    </Stack>
                  </AccordionSummary>
                  <AccordionDetails primary> {/* This custom prop is from your theme.js! */}
                    <Typography color="secondary.main">{faqItem.answer}</Typography>
                  </AccordionDetails>
                </Accordion>
              ))}
            </Box>
            {/* </Stack> */}
          </Stack>
        )}
      </Stack>
    </Box>
  );
};

export default FaqPage;